module.exports = __webpack_public_path__ + "assets/Cut2RectanglesDetailed.7ff7b16d8eaf942a3aa4ff1004986d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Cut2RectanglesDetailed.png
// module id = 499
// module chunks = 0